import { DATE_BUCKET_TO_DATE_GAP } from '@fabric-ui/components';
import { TimeBucket, TimeBucketToDateGap } from '@fabric-ui/components/Table';
import { DateFormats } from '@fabric-ui/utils';
import { getDateBucketFromExpression, isDateTruncExpression } from '../CustomDashboardsUtils/expressionUtils';
import {
  BarCategoryWidgetTypes,
  LineCategoryWidgetTypes,
  PieCategoryWidgetTypes,
  TileCategoryWidgetTypes,
  TileWidgetVisualization,
} from '../types';
import { hasTimeBucket } from './components/TimeBucketBreakdown/utils';

export const getDateFormatFromWidget = (
  widget: LineCategoryWidgetTypes | BarCategoryWidgetTypes | PieCategoryWidgetTypes | TileCategoryWidgetTypes
) => {
  if (widget.requests[0].timeRange) {
    const selectedTimeBucket = widget.requests[0].select.dims.find(({ name }) => hasTimeBucket(name))?.name;
    if (selectedTimeBucket === TimeBucket.BUCKET_MONTH) {
      return DateFormats.MonYear;
    }
    return DateFormats[TimeBucketToDateGap[selectedTimeBucket || '']];
  }

  const dimWithExpression = widget.requests[0].select.dims.find(dim => dim.expression);
  if (dimWithExpression?.expression && isDateTruncExpression(dimWithExpression.expression)) {
    return DateFormats[DATE_BUCKET_TO_DATE_GAP[getDateBucketFromExpression(dimWithExpression.expression)]];
  }

  return "MM/dd/yyyy', ' HH':'mmm':'ss";
};

export const visualizationOptions = [
  { label: TileWidgetVisualization.None, value: TileWidgetVisualization.None },
  { label: TileWidgetVisualization.Progress, value: TileWidgetVisualization.Progress },
];
